export const RENDERER_TYPES = Object.freeze({
  i18nTextField: "i18nTextField",
  i18nHtmlEditor: "i18nHtmlEditor",
  i18nTextArea: "i18nTextArea",
  i18nAutocomplete: "i18nAutocomplete",
  hierarchicalSelect: "hierarchicalSelect",
  htmlEditor: "htmlEditor",
  colorPicker: "colorPicker",
  autocomplete: "autocomplete",
  select: "select",
  toggleButton: "toggleButton",
  fileInput: "fileInput",
  datePicker: "datePicker",
  fileHandler: "fileHandler",
  emailField: "emailField",
  websiteField: "websiteField",
  imagePicker: "imagePicker",
  groupedSelect: "groupedSelect"
});

export const validationMode = Object.freeze({
  show: "ValidateAndShow",
  hide: "ValidateAndHide"
});
